import { render, staticRenderFns } from "./input-checkbox.vue?vue&type=template&id=8ffd6584&scoped=true&"
import script from "./input-checkbox.vue?vue&type=script&lang=js&"
export * from "./input-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./input-checkbox.vue?vue&type=style&index=0&id=8ffd6584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd6584",
  null
  
)

component.options.__file = "input-checkbox.vue"
export default component.exports